export default __webpack_public_path__ + "static/media/Orsi.af0a4573.jpg";